import { Injectable, EventEmitter } from '@angular/core';
// import { Http, Response, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { BaseService } from './base.service';
import { ConfigService } from './config.service';
import { AsyncSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

declare var Oidc: any;

export enum AppRoles {
    "Administrator",
    "Developer",
    "Store Manager",
  }

@Injectable()
export class AuthService extends BaseService {

    public IsAuthorized: boolean;
    public IsInitialized: boolean = false;
    userLoadedEvent: EventEmitter<any> = new EventEmitter<any>();
    userMissingEvent: EventEmitter<any> = new EventEmitter<any>();
    mgr: any;
    currentUser:any;

    // Allows us to wait until user is loaded,
    // then returns immediately after it has
    userLoaded = new AsyncSubject<Boolean>();

    constructor(private _configService: ConfigService,
                private router: Router) {
        super();
    }

    public Init() {

        if (this.IsInitialized) {
            // console.log("Already Initialized!");
            return;
        }

        // console.log("Initializing");
        
        // userLoaded hangs until complete() is called
        // allowing us to wait until user is loaded
        this.userLoadedEvent.subscribe(() => {
            this.userLoaded.next(true);
            this.userLoaded.complete();
        })

        var settings: any = {
            authority: ConfigService.OIDC_AUTHORITY,
            client_id: ConfigService.OIDC_CLIENT_ID,
            redirect_uri: ConfigService.OIDC_REDIRECT_URL,
            post_logout_redirect_uri: ConfigService.OIDC_POST_LOGOUT_URL,
            response_type: ConfigService.OIDC_RESPONSE_TYPE,
            scope: ConfigService.OIDC_SCOPE,

            silent_redirect_uri: ConfigService.OIDC_SILENT_CALLBACK_URL,
            automaticSilentRenew: true,
            //silentRequestTimeout:10000,

            filterProtocolClaims: false,
            loadUserInfo: true,
            metadataUrl: ConfigService.OIDC_METADATA_URL,
            //userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }) //remove this if you want session storage
        };

        this.mgr = new Oidc.UserManager(settings);

        this.mgr.events.addUserUnloaded(() => {
            // console.log("user unloaded");
            this.IsAuthorized = false;
            this.userMissingEvent.emit();
        });

        return this.mgr.getUser()
            .then(async (user:any) => {
                if (user) {
                    // console.log('user found');
                    this.IsAuthorized = true;
                    this.currentUser = user;
                    this.userLoadedEvent.emit(user);
                    
                    try {
                        console.log('Querying session...');
                        var session = await this.mgr.querySessionStatus();
                        console.log('Current user login status is OK')
                    } catch (error) {
                        
                        console.log('Current user login status is invalid, logging out')
                        this.Logoff();
                    }
                }
                else {
                    //console.log('user not found');
                    this.userMissingEvent.emit();
                    this.IsAuthorized = false;
                }
                this.IsInitialized = true;
            })
            .catch(() => {
                    //console.log('user not found with error');
                    this.IsAuthorized = false;
                    this.userMissingEvent.emit();
                    this.IsInitialized = true;
                });
        
            
    }

    public Authorize() {
        this.Init();
        // console.log('Authorizing...');
        this.mgr.signinRedirect().then(function () {
            //console.log("signinRedirect done");
        }).catch(function (err:any) {
            console.error(err);
        });
    }

    public AuthorizedCallback() {
        this.Init();
        // console.log('Authorize Callback...');
        
        return this.mgr.signinRedirectCallback({ loadUserInfo: true, filterProtocolClaims: true }).then((user:any)=> {
            // console.log("signed in", user);
            this.currentUser = user;
            //this.currentUser.bind(this) = user;
            this.IsAuthorized = true;
            this.userLoadedEvent.emit(user);
            //BaseService.SetTokenReference(Observable.from(this.GetToken());
        }).catch((err:any) => {
            //suppress this error, it seems to happen even on page reload
            //might be an anomoly that only happens on local dev server
            
            // console.log("error in signinRedirect");
            // console.error(err);
            // this.RedirectToLogin();
        });
        
    }

    private RedirectToLogin() {
        console.log("redirecting to login");
        this.router.navigate(["/"]).then(result=>{window.location.href = ConfigService.OIDC_AUTHORITY;});
    }

    public Logoff() {
        //console.error('Logging off...');
        this.mgr.signoutRedirect().then(()  => {
            console.log("Signed out");
        }).catch(function (err:any) {
            console.log(err);
        });
    }

    // Returns a promise that only resolves when the user is finished authenticating
    // Returns the same whether authentication succeeds or fails
    public waitUntilUserLoaded() : Promise<any> {
        // Wait until Config loaded as well
        return this._configService.waitUntilConfigLoaded().then(() => {
            return new Promise(resolve => {
                this.userLoaded.subscribe(() => {
                    resolve();
                })
            })
        }) 
    }

    public GetToken() : Promise<any> {
        return this.waitUntilUserLoaded().then(() => {
            return this.mgr.getUser().then((user:any) => {
                if (user == null || user == undefined) 
                    return null;
    
                return user.access_token;
            }) 
        }); 
    }

    public IsExpired() : Promise<any> {
        return this.waitUntilUserLoaded().then(() => {
            return this.mgr.getUser().then((user:any) => {
                if (user == null || user == undefined)
                    return null;

                return user.expired;
            });
        })
    }

    public RemoveUser() : Promise<any> {
        return this.mgr.removeUser();
    }

    public GetDefaultHeaders() : Promise<HttpHeaders> {
        this.IsExpired().then(expired => { if (expired) this.Logoff() });

        // Return default headers with auth token added
        return super.GetDefaultHeaders().then((contentHeaders: HttpHeaders) => {
            return this.GetToken().then((token: any) => {
                return contentHeaders.append('Authorization', 'Bearer ' + token);
            })
        })  
    }

    public IsSuperuser() {
        var result = false;
        if (this.currentUser.profile.role)
            result = Object.values(AppRoles).filter(x => this.currentUser.profile.role.includes(x)).length > 0;
        else
            result = false;

        return result;
    }

}
